import { createAsyncThunk } from '@reduxjs/toolkit';
import { handleError, handleResponse, MyAxios } from '@services/SettingAxios';
import { PaymentLink } from '../types/paymentSchema';
import { RegionQueryDto } from './api.dto';

export const getPaymentListByRegion = createAsyncThunk<PaymentLink[], RegionQueryDto>('payment/getPaymentListByRegion', async query => {
  return await MyAxios.get(`/api/order/payments?regionId=${query.regionId}`).then(handleResponse).catch(handleError);
});
